export const EMAIL_LOOKUP = '/email-lookup';
export const FORGOT_PASSWORD = '/forgot-password';
export const LOGIN = '/login';
export const REGISTER = '/register';
export const MOBILE_INTERCEPT = '/mobile-callback';
